import { render, staticRenderFns } from "./MyInterests.vue?vue&type=template&id=f242419e&"
import script from "./MyInterests.vue?vue&type=script&lang=js&"
export * from "./MyInterests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports